import React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import Home from "./screens/Home/index";
import ThankYou from "./screens/ThankYou/index";
import AdminPanelHome from "./screens/AdminPanel/AdminPanelHome/index";
import DeletionStatus from "./screens/DeletionStatus";

export default function Routes(props) {
  const { isMobile } = props;
  return (
    <Router>
      <Switch>
        <Route
          exact
          path={["/home", "/"]}
          render={(props) => <Home isMobile={isMobile} {...props} />}
        />

        <Route
          exact
          path="/thankyou"
          render={(props) => <ThankYou isMobile={isMobile} {...props} />}
        />
        <Route
          exact
          path="/image-gallery"
          render={(props) => (
            <Home isMobile={isMobile} imageGallery={true} {...props} />
          )}
        />
        <Route exact path="/admin" component={AdminPanelHome} />
        <Route exact path="/deletion/:id" component={DeletionStatus} />
      </Switch>
    </Router>
  );
}
